module.exports = {
    HOST: "https://hppyhr.herokuapp.com"
};
